import { render, staticRenderFns } from "./PasswordRecoveryEmailConfirmation.vue?vue&type=template&id=7b945652&lang=pug&"
import script from "./PasswordRecoveryEmailConfirmation.vue?vue&type=script&lang=ts&"
export * from "./PasswordRecoveryEmailConfirmation.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports